// Copyright 2025, University of Maryland, All Rights Reserved
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { BookOpen } from "lucide-react"
import { AmendmentTypeGuide } from './AmendmentTypeGuide'
import { type ProcessedAmendmentData } from './types'

interface AmendmentSummaryCardProps {
  amendmentData: ProcessedAmendmentData
}

export function AmendmentSummaryCard({ amendmentData }: AmendmentSummaryCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <BookOpen className="h-5 w-5" />
          Amendment Summary - Version {amendmentData.version_number}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 p-4 bg-slate-50 dark:bg-slate-800 rounded-lg">
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600">{amendmentData.summary.total_amendments}</div>
            <div className="text-sm text-muted-foreground">Total Amendments</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-red-600">{amendmentData.summary.strikeout_count}</div>
            <div className="text-sm text-muted-foreground">Matter Stricken</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600">{amendmentData.summary.underline_count}</div>
            <div className="text-sm text-muted-foreground">Amendments to Bill</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-orange-600">{amendmentData.summary.italics_count}</div>
            <div className="text-sm text-muted-foreground">Chamber/Committee</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-purple-600">{amendmentData.summary.pages_with_amendments}</div>
            <div className="text-sm text-muted-foreground">Pages Affected</div>
          </div>
        </div>
        
        <AmendmentTypeGuide />
      </CardContent>
    </Card>
  )
}
